import * as types from "./actionTypes";
import { Map } from "immutable";

const initState = Map();

const reducer = (error = initState, action) => {
  switch (action.type) {
    case types.SHOW_LOGGED_OUT_MESSAGE:
      return error.set("show", true).set("type", "logged-out");
    case types.SHOW_REQUEST_FAILED_MESSAGE:
      return error.set("show", true).set("type", "request-failed");
    case types.HIDE_LOGGED_OUT_MESSAGE:
      return error.set("show", false);
    default:
      return error;
  }
};

export default reducer;
